import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IAppletBasicInfoParam, IAppletCancelAuth, IAppletConfigDetail, IAppletDomain, IAppletJumpDomain, IAppletManageItem, IWxTemplate } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 小程序配置 - 详情
 */
export async function queryAppletConfigDetail() {
  let data = {} as IAppletConfigDetail;

  try {
    const { code, context, message } = await Http.get<IAppletConfigDetail>(`${hostUrl}/oem/applet/config-detail`);

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || {} as IAppletConfigDetail;

      data = items || {} as IAppletConfigDetail;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 小程序配置 - 服务器域名
 */
export async function updateAppletServer(params: IAppletDomain) {

  try {
    const { code, message } = await Http.post<IAppletConfigDetail>(`${hostUrl}/oem/applet/config-server-domain`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 小程序配置 - 业务域名
 */
export async function updateAppletJumpDomain(params: IAppletJumpDomain) {

  try {
    const { code, message } = await Http.post<IAppletConfigDetail>(`${hostUrl}/oem/applet/config-business-domain`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 小程序配置 - 版本列表
 */
export async function queryAppletVersionList() {
  let data = [] as IWxTemplate[];

  try {
    const { code, context, message } = await Http.get<IWxTemplate[]>(`${hostUrl}/oem/applet/getVersionList`);

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || [] as IWxTemplate[];

      data = items || [] as IWxTemplate[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 小程序配置 - 设置版本信息
 */
export async function updateAppletVersion(tempId: number) {

  try {
    const { code, message } = await Http.get<IAppletConfigDetail>(`${hostUrl}/oem/applet/setVersion`, { tempId });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 小程序配置 - 发布公共小程序配置
 */
export async function updatePublicApplet(appletId: number) {

  try {
    const { code, message } = await Http.post<IAppletConfigDetail>(`${hostUrl}/oem/applet/common/save`, { appletId });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 小程序授权 - 详情
 */
export async function queryAppletDetail(agentId: number) {
  let data = {} as IAppletManageItem;

  try {
    const { code, context, message } = await Http.post<IAppletManageItem>(`${hostUrl}/oem/applet/detail`, { agentId });

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || {} as IAppletManageItem;

      data = items || {} as IAppletManageItem;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 小程序授权 - 获取小程序授权链接
 */
export async function queryComponentSrc(agentId: number) {
  let src = '' as string;

  try {
    const { code, context, message } = await Http.get<string>(`${hostUrl}/oem/applet/getComponentLoginPage`, { agentId });

    if (code === EAxiosResponseCode.Succeed) {
      src = context || '' as string;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return src;
}

/**
 * 小程序授权 - 取消授权
 */
export async function cancelAppletAuth(params: IAppletCancelAuth) {
  try {
    const { code, message } = await Http.post<IAppletCancelAuth>(`${hostUrl}/oem/applet/cancelAuth`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 小程序授权 - 基本信息配置
 */
export async function updateAppletBasicInfo(params: IAppletBasicInfoParam) {
  try {
    const { code, message } = await Http.post<IAppletBasicInfoParam>(`${hostUrl}/oem/applet/basie`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}